// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbsContainer":"Breadcrumbs_breadcrumbsContainer__MH466","breadcrumbs":"Breadcrumbs_breadcrumbs__6Kuu5","crumb":"Breadcrumbs_crumb__DYlhr"};